import React from "react";

import './header.css';

const Header = () => {
     return null;
}

export default Header;